import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/** FloatingCtaBar 고정 영역 높이 — 버튼(62px) + 상하 패딩(40px) */
const FLOATING_CTA_HEIGHT = 102

export const LandingContainer = styled.div`
  position: relative; /* SoldOutOverlay(absolute) 기준 — 헤더 아래 콘텐츠 영역만 덮도록 */
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${COLORS.bgWhite};
`

export const LandingScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  /* 하단 고정 CTA에 마지막 섹션이 가리지 않도록 여백 확보 */
  padding-bottom: calc(${FLOATING_CTA_HEIGHT}px + var(--safe-bottom, 0px));
`
